function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useEffect, useRef, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import PropTypes, { string } from 'prop-types';
import { IconContainer, InputFileHiddenStyles, InputImageContainer, LeftSideContainer, StyledFileContainer, StyledInputFileTextContainer } from './InputImage.styles';
import Icon from '../Icon/Icon';
import Text from '../Text/Text';
import Button from '../Button/Button';
import Alert from '../Alert/Alert';
import { elo as theme } from '../../themes';
import FileAddButton from '../Files/FileAddButton';
import File from '../Files/File';
import iconList from '../Icon/iconList';
import FileVisualizationDialog from './FileVisualizationDialog';
import { useInputFiles } from './useInputFiles';
import { jsx as ___EmotionJSX } from "@emotion/core";
var InputFiles = function InputFiles(_ref) {
  var title = _ref.title,
    _ref$maxFileSize = _ref.maxFileSize,
    maxFileSize = _ref$maxFileSize === void 0 ? 25 : _ref$maxFileSize,
    maxFileSizeErrorText = _ref.maxFileSizeErrorText,
    _ref$maxFileSizeError = _ref.maxFileSizeErrorTitle,
    maxFileSizeErrorTitle = _ref$maxFileSizeError === void 0 ? 'Tamanho máximo atingido' : _ref$maxFileSizeError,
    dataTestId = _ref.dataTestId,
    _ref$allowMultipleFil = _ref.allowMultipleFiles,
    allowMultipleFiles = _ref$allowMultipleFil === void 0 ? false : _ref$allowMultipleFil,
    _ref$acceptedFormats = _ref.acceptedFormats,
    acceptedFormats = _ref$acceptedFormats === void 0 ? ['jpg', 'jpeg', 'png'] : _ref$acceptedFormats,
    acceptedFormatsErrorText = _ref.acceptedFormatsErrorText,
    _ref$acceptedFormatsE = _ref.acceptedFormatsErrorTitle,
    acceptedFormatsErrorTitle = _ref$acceptedFormatsE === void 0 ? 'Não foi possível adicionar seus arquivos' : _ref$acceptedFormatsE,
    onAddFiles = _ref.onAddFiles,
    _ref$maxFiles = _ref.maxFiles,
    maxFiles = _ref$maxFiles === void 0 ? 5 : _ref$maxFiles,
    maxFilesErrorText = _ref.maxFilesErrorText,
    _ref$maxFilesErrorTit = _ref.maxFilesErrorTitle,
    maxFilesErrorTitle = _ref$maxFilesErrorTit === void 0 ? 'Número máximo de arquivos excedido' : _ref$maxFilesErrorTit,
    buttonText = _ref.buttonText,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? 'image' : _ref$icon,
    description = _ref.description,
    files = _ref.files,
    onRemoveFile = _ref.onRemoveFile,
    _ref$defaultErrorText = _ref.defaultErrorText,
    defaultErrorText = _ref$defaultErrorText === void 0 ? "Por favor, tente novamente mais tarde. \n        Se o problema persistir, entre em contato com o nosso suporte." : _ref$defaultErrorText,
    _ref$defaultErrorTitl = _ref.defaultErrorTitle,
    defaultErrorTitle = _ref$defaultErrorTitl === void 0 ? 'Não foi possível adicionar o arquivo' : _ref$defaultErrorTitl;
  var _useState = useState('large'),
    containerSize = _useState[0],
    setContainerSize = _useState[1];
  var containerRef = useRef(null);
  var isMobile = useMediaQuery({
    query: theme.breakpoints.mobile
  });
  var _useInputFiles = useInputFiles({
      files: files,
      maxFiles: maxFiles,
      acceptedFormats: acceptedFormats,
      maxFileSize: maxFileSize,
      maxFilesErrorTitle: maxFilesErrorTitle,
      maxFilesErrorText: maxFilesErrorText,
      defaultErrorTitle: defaultErrorTitle,
      defaultErrorText: defaultErrorText,
      acceptedFormatsErrorTitle: acceptedFormatsErrorTitle,
      acceptedFormatsErrorText: acceptedFormatsErrorText,
      maxFileSizeErrorTitle: maxFileSizeErrorTitle,
      maxFileSizeErrorText: maxFileSizeErrorText,
      dataTestId: dataTestId,
      onAddFiles: onAddFiles,
      onRemoveFile: onRemoveFile
    }),
    error = _useInputFiles.error,
    currentImageIndex = _useInputFiles.currentImageIndex,
    setCurrentImageIndex = _useInputFiles.setCurrentImageIndex,
    addFiles = _useInputFiles.addFiles,
    handleFileClick = _useInputFiles.handleFileClick,
    inputFileRef = _useInputFiles.inputFileRef,
    setError = _useInputFiles.setError;
  useEffect(function () {
    var currentContainer = containerRef.current;
    var resizeObserver = new ResizeObserver(function (_ref2) {
      var entry = _ref2[0];
      var width = entry.contentRect.width;
      setContainerSize(width < 500 ? 'small' : 'large');
    });
    if (currentContainer) {
      resizeObserver.observe(currentContainer);
    }
    return function () {
      if (currentContainer) {
        resizeObserver.unobserve(currentContainer);
      }
    };
  }, []);
  return ___EmotionJSX(React.Fragment, null, error && ___EmotionJSX(Alert, {
    title: error.title,
    primaryButtonText: "Fechar",
    onPrimaryClick: function onPrimaryClick() {
      return setError(null);
    },
    onClose: function onClose() {
      return setError(null);
    },
    secondaryButtonText: "",
    variant: "negative"
  }, error.message), ___EmotionJSX(InputFileHiddenStyles, {
    "data-test-id": dataTestId,
    type: "file",
    tabIndex: "-1",
    ref: function ref(node) {
      inputFileRef.current = node;
    },
    onChange: addFiles,
    multiple: allowMultipleFiles,
    accept: acceptedFormats.map(function (format) {
      return "." + format;
    }).join(', ')
  }), ___EmotionJSX(FileVisualizationDialog, {
    files: files,
    setCurrentImageIndex: setCurrentImageIndex,
    currentImageIndex: currentImageIndex
  }), ___EmotionJSX("div", {
    ref: containerRef
  }, !files.length ? ___EmotionJSX(InputImageContainer, {
    containerSize: containerSize
  }, ___EmotionJSX(LeftSideContainer, {
    containerSize: containerSize
  }, ___EmotionJSX(IconContainer, null, ___EmotionJSX(Icon, {
    type: icon,
    secondary: true
  })), ___EmotionJSX(StyledInputFileTextContainer, {
    isContainerSizeSmall: containerSize === 'small'
  }, title && ___EmotionJSX(Text, {
    size: "t2",
    semibold: true,
    display: "flex"
  }, title), description && ___EmotionJSX(Text, {
    size: "t3",
    secondary: true
  }, description))), ___EmotionJSX(Button, {
    dataTestId: dataTestId + "-button",
    secondary: true,
    onClick: handleFileClick,
    size: isMobile ? 'large' : 'medium',
    fullWidth: containerSize === 'small'
  }, ___EmotionJSX(Text, {
    size: "t2",
    bold: true,
    alignment: "center",
    element: "span",
    variant: "brand"
  }, buttonText))) : ___EmotionJSX(StyledFileContainer, null, ___EmotionJSX(React.Fragment, null, files == null ? void 0 : files.map(function (file) {
    return ___EmotionJSX(File, _extends({
      key: file.id
    }, file));
  })), allowMultipleFiles && files.length < maxFiles && ___EmotionJSX(FileAddButton, {
    onClick: handleFileClick
  }))));
};
InputFiles.propTypes = {
  dataTestId: PropTypes.string,
  maxFileSize: PropTypes.number,
  maxFileSizeErrorText: PropTypes.string,
  onAddFiles: PropTypes.func,
  title: PropTypes.string.isRequired,
  allowMultipleFiles: PropTypes.bool,
  acceptedFormats: PropTypes.arrayOf(string),
  acceptedFormatsErrorText: PropTypes.string,
  maxFiles: PropTypes.number,
  maxFilesErrorText: PropTypes.string,
  maxFilesErrorTitle: PropTypes.string,
  buttonText: PropTypes.string.isRequired,
  icon: PropTypes.oneOf([].concat(Object.keys(iconList), [''])),
  description: PropTypes.string,
  files: PropTypes.arrayOf(PropTypes.shape({
    file: PropTypes.object,
    id: PropTypes.string,
    src: PropTypes.string,
    type: PropTypes.string,
    size: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    variant: PropTypes.oneOf(['negative']),
    maxWidth: PropTypes.string,
    onClick: PropTypes.func,
    onRemoveClick: PropTypes.func,
    dataTestId: PropTypes.string,
    buffer: PropTypes.object
  })).isRequired,
  onRemoveFile: PropTypes.func,
  defaultErrorText: PropTypes.string,
  defaultErrorTitle: PropTypes.string,
  maxFileSizeErrorTitle: PropTypes.string,
  acceptedFormatsErrorTitle: PropTypes.string
};
export default InputFiles;